import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import { MdAdd, MdDeleteOutline } from "react-icons/md";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "../Shared_Components/Loader";
import Paper from "@mui/material/Paper";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineUnlock } from "react-icons/ai";
import { API_HOST } from "../api_utils";

function Users(props) {
  const [open, setOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [userModalData, setUserModalData] = useState({});
  const [loading, setLoading] = useState(false);
  const [managerList, setManagerList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userAddSuccess, setUserAddSuccess] = useState(false);
  const [editUser, setEditUser] = useState(false);

  // add user by admin state :
  const [addUserData, setAddUserData] = useState({
    first_name: "",
    last_name: "",
    login_name: "",
    mobile_number: null,
    password: "",
    gender: "",
    user_role: "",
    state: "",
    street_name: "",
    post_code: "",
    status: "Active",
    manager: null,
    house_number: null,
    id_number: "",
    initials: null,
    suburb: null,
    start_date: "",
  });

  // edit user by admin state:
  const [editUserData, setEditUserData] = useState({});
  const [confirmPass, setConfirmPass] = useState("");

  // states for delete user :
  const [deleteModalUser, setDeleteModalUser] = useState(false);

  // state for password update modal:
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [editPass, setEditPass] = useState({
    new_password: "",
    confirm_password: "",
  });

  // states to filter usersList table:
  const [lastNameToFilter, setLastNameToFilter] = useState("");
  const [loginNameToFilter, setLoginNameToFilter] = useState("");
  const [statusToFilter, setStatusToFilter] = useState("Active");
  const [userRoleToFilter, setUserRoleFilter] = useState("");
  const [filteredData, setFilterData] = useState([]);
  const [editUserSuccess, setEditUserSuccess] = useState(false);

  const { userDataFromStorage, coloredTheme } = props;

  const createUserHandler = () => {
    if (
      userDataFromStorage.user_role === "admin" ||
      userDataFromStorage.user_role === "manager"
    ) {
      setOpen(true);
    } else {
      toast.warn("Authentication Required !!!");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const stateList = [
    {
      name: "Johor",
      id: 1,
    },
    {
      name: "Kedah",
      id: 2,
    },
    {
      name: "Kelantan",
      id: 3,
    },
    {
      name: "Negeri Semibilan",
      id: 4,
    },
    {
      name: "Pahang",
      id: 5,
    },
    {
      name: "Penang",
      id: 6,
    },
    {
      name: "Perak",
      id: 7,
    },
    {
      name: "Perlis",
      id: 8,
    },
    {
      name: "Sabah",
      id: 9,
    },
    {
      name: "Sarawak",
      id: 10,
    },
    {
      name: "Selangor",
      id: 11,
    },
    {
      name: "Terrenganu",
      id: 12,
    },
    {
      name: "Wilayah Persekutuan",
      id: 13,
    },
  ];

  const handleUserRegistration = async () => {
    if (
      addUserData.login_name &&
      addUserData.password &&
      confirmPass &&
      addUserData.last_name
    ) {
      if (addUserData.manager === "none") {
        toast.error(
          "Make Sure To Select A manager Otherwise Refresh The Page !!!"
        );
      } else {
        if (addUserData.password === confirmPass) {
          if (addUserData.mobile_number) {
            if (
              !isNaN(parseInt(addUserData?.mobile_number)) &&
              addUserData?.mobile_number.length > 6
            ) {
              setLoading(true);
              try {
                const config = {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userDataFromStorage.token}`,
                  },
                };
                const data = await axios.post(
                  `${API_HOST}/api/users/`,
                  addUserData,
                  config
                );

                if (data.status === 200) {
                  console.log("data1", data);
                  setLoading(false);
                  setOpen(false);
                  setUserAddSuccess(true);
                  setAddUserData({
                    first_name: "",
                    last_name: "",
                    login_name: "",
                    mobile_number: null,
                    password: "",
                    gender: "",
                    user_role: "",
                    state: "",
                    street_name: "",
                    post_code: "",
                    status: "Active",
                    manager: null,
                    house_number: null,
                    id_number: "",
                    initials: null,
                    suburb: null,
                    start_date: "",
                  });
                  toast.success(data.message);
                } else {
                  console.log("data2", data);
                  setLoading(false);
                  setOpen(false);
                  toast.error(data.message);
                }
              } catch (error) {
                toast.error(error.response.data.message);
              }
            } else {
              toast.warn("Please provide a valid mobile number!!!");
            }
          } else {
            setLoading(true);
            try {
              const config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${userDataFromStorage.token}`,
                },
              };
              const data = await axios.post(
                `${API_HOST}/api/users/`,
                addUserData,
                config
              );

              if (data.status === 200) {
                console.log("data1", data);
                setLoading(false);
                setOpen(false);
                setUserAddSuccess(true);
                setAddUserData({
                  first_name: "",
                  last_name: "",
                  login_name: "",
                  mobile_number: null,
                  password: "",
                  gender: "",
                  user_role: "",
                  state: "",
                  street_name: "",
                  post_code: "",
                  status: "Active",
                  manager: null,
                  house_number: null,
                  id_number: "",
                  initials: null,
                  suburb: null,
                  start_date: "",
                });
                toast.success(data.message);
              } else {
                console.log("data2", data);
                setLoading(false);
                setOpen(false);
                toast.error(data.message);
              }
            } catch (error) {
              toast.error(error.response.data.message);
            }
          }
        } else {
          toast.error("Password and Confirm Password didn't Match");
        }
      }
    } else {
      toast.error("Make Sure To Fill All Required Fields !!!");
    }
  };

  // getManagerAPI:
  const getManagerListCall = async () => {
    setLoading(true);

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_HOST}/api/users/get_manager_list`,
      config
    );
    if (data) {
      if (data.message) {
        setLoading(false);
        toast.error(data.message);
      } else {
        console.log("dsatas:::::::::::", data);
        setLoading(false);
        setManagerList(data);
      }
    }
  };

  // getUserListAPI:
  const getUserListCall = async () => {
    setLoading(true);
    const { userDataFromStorage } = props;

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const { data } = await axios.get(`${API_HOST}/api/users/`, config);
    if (data) {
      if (data.message) {
        setLoading(false);
        toast.error(data.message);
      } else {
        setLoading(false);
        setUserList(data);
        setFilterData(data);
      }
    }
  };

  // get manager list:
  // update userList after adding a user:
  useEffect(() => {
    getManagerListCall();
    getUserListCall();

    return () => {
      setUserAddSuccess(false);
      setEditUserSuccess(false);
    };
  }, [userAddSuccess, editUserSuccess]);

  const mobileNumberHandler = (e) => {
    const regex = /^[0-9]{0,10}$/;
    const telValue = e.target.value;

    if (regex.test(telValue)) {
      setAddUserData((prevState) => ({
        ...prevState,
        mobile_number: Number(telValue),
      }));
    } else {
      toast.warn("Please Provide Valid Mobile Number !!!");
    }
  };

  // user's modal handler:
  const usersModalHandler = (data) => {
    console.log("data:::::::", data);
    setUserModalData({
      ...data,
      user_role:
        data.is_manager === true
          ? "manager"
          : data.is_admin === true
          ? "admin"
          : data.is_agent === true
          ? "agent"
          : "senior_agent",
    });
    setUserOpen(true);
  };

  const handleUserClose = () => {
    setUserOpen(false);
  };

  // edit user's modal:
  const handleEditUserClose = () => {
    setEditUser(false);
  };

  const editUserModalHandler = () => {
    setEditUser(true);
    console.log("userModalData::::::", userModalData);
    setEditUserData(userModalData);
  };

  const handleUserEditHandler = async () => {
    if (
      editUserData.first_name ||
      editUserData.last_name ||
      editUserData.login_name ||
      addUserData.house_number ||
      editUserData.street_name ||
      editUserData.state ||
      editUserData.post_code ||
      editUserData.gender ||
      editUserData.mobile_number ||
      editUserData.id_number ||
      editUserData.manager
    ) {
      console.log("editUserData:::::::", editUserData);
      if (editUserData.id_number && editUserData.id_number.length < 50) {
        setLoading(true);
        try {
          const config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userDataFromStorage.token}`,
            },
          };
          const data = await axios.put(
            `${API_HOST}/api/users/${userModalData._id}`,
            editUserData,
            config
          );

          if (data) {
            if (!data.message) {
              setLoading(false);
              setEditUser(false);
              toast.success(data.message);
              setEditUserSuccess(true);
            } else {
              setLoading(false);
              toast.error(data.message);
            }
          } else {
            setLoading(false);
            toast.error("Something Went Wrong !!!");
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      }

      if (!editUserData.id_number) {
        setLoading(true);
        try {
          const config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userDataFromStorage.token}`,
            },
          };
          const data = await axios.put(
            `${API_HOST}/api/users/${userModalData._id}`,
            editUserData,
            config
          );

          if (data) {
            if (!data.message) {
              setLoading(false);
              setEditUser(false);
              toast.success(data.message);
              setUserAddSuccess(true);
            } else {
              setLoading(false);
              toast.error(data.message);
            }
          } else {
            setLoading(false);
            toast.error("Something Went Wrong !!!");
          }
        } catch (error) {
          toast.error(error.response.data.message);
        }
      }
    } else {
      toast.error("Make Sure To Fill All Fields !!!");
    }
  };

  const handleUserRoleChange = (event) => {
    const value = event.target.value;

    setEditUserData((prevState) => ({
      ...prevState,
      is_admin: value === "admin",
      is_manager: value === "manager",
      is_senior_agent: value === "senior_agent",
      is_agent: value === "agent",
      user_role: value,
    }));
  };

  // handle Delete user modal:
  const handleDeleteModal = () => {
    setDeleteModalUser(false);
  };

  const deleteUserByAdminHandler = async () => {
    setLoading(true);
    if (userModalData._id) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };
      const data = await axios.delete(
        `${API_HOST}/api/users/${userModalData.employee_number}`,
        config
      );

      if (data) {
        if (data.status === 200) {
          setLoading(false);
          setDeleteModalUser(false);
          toast.success(data.data.message);
          setUserAddSuccess(true);
        } else {
          setLoading(false);
          toast.error(data.data.message);
        }
      } else {
        setLoading(false);
        toast.error("Something Went Wrong !!!");
      }
    } else {
      setLoading(false);
      toast.error("Something went wrong !!!");
    }
  };

  const updatePasswordByAdminHandler = async () => {
    setLoading(true);
    if (editPass.new_password && editPass.confirm_password) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const data = await axios.put(
        `${API_HOST}/api/users/change_password/${userModalData._id}`,
        editPass,
        config
      );
      if (data) {
        if (data.status === 200) {
          setLoading(false);
          toast.success(data.data.message);
          setPasswordModalOpen(false);
        } else {
          setLoading(false);
          toast.error(data.data.message);
        }
      } else {
        setLoading(false);
        toast.error("Something Went Wrong !!!");
      }
    } else {
      setLoading(false);
      toast.warn("Make Sure To Fill All Fields !!!");
    }
  };

  useEffect(() => {
    // Filter User List Based On Filter Options:
    let filteredData1 = userList.filter((user) => {
      if (
        (!lastNameToFilter || user.last_name === lastNameToFilter) &&
        (!statusToFilter || user.status === statusToFilter) &&
        (!loginNameToFilter ||
          user.login_name.toLowerCase() === loginNameToFilter.toLowerCase()) &&
        (!userRoleToFilter || user?.user_role === userRoleToFilter)
      ) {
        return true;
      }
      return false;
    });
    setFilterData(filteredData1);
  }, [
    lastNameToFilter,
    statusToFilter,
    loginNameToFilter,
    userRoleToFilter,
    managerList,
  ]);

  useEffect(() => {
    if (userList.length) {
      let filterData1 = userList.filter(
        (user) => user.status === statusToFilter
      );
      setFilterData(filterData1);

      if (userModalData) {
        let modalData = filterData1.find(
          (x) => x.employee_number === userModalData.employee_number
        );
        setUserModalData(modalData);
      }
    }
  }, [userList]);

  const handleUserRole = (value) => {
    if (userRoleToFilter === value) {
      setUserRoleFilter("");
    } else {
      setUserRoleFilter(value);
    }
  };

  const handleUserStatus = (value) => {
    const regex = new RegExp(`^${statusToFilter}$`, "i");
    const regex1 = new RegExp(`^${value}$`, "i");
    if (regex === regex1) {
      setStatusToFilter("");
    } else {
      setStatusToFilter(regex1);
    }
  };

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[2rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50"
      }>
      {loading ? (
        <Loader />
      ) : (
        <>
          <p className="text-gray-800 text-[1.8rem] tracking-wider">
            User management
          </p>
          {/* main section goes here */}
          <div className="md:grid grid-cols-12 gap-x-[1rem] mt-[2%] ">
            {/* left portion */}
            <div className="xl:col-span-3 md:col-span-4  bg-white mb-8 md:mb-0">
              {/* search bar head */}
              <div
                style={{ backgroundColor: coloredTheme }}
                className={`border  flex justify-between p-[0.8rem] text-white items-center`}>
                <p>Search Users</p>
                <FiSearch />
              </div>
              {/* input fields */}
              {/* <div className="p-[1rem]">
                <label htmlFor="lastname tracking-wider">Mgr. LastName</label>
                <div className="border border-gray-700 overflow-hidden  mt-2  flex justify-between md:justify-start items-center">
                  <input
                    value={lastNameToFilter}
                    onChange={(e) => setLastNameToFilter(e.target.value)}
                    id="lastname"
                    type={"text"}
                    className=" lg:flex-grow md:px-[0.5rem] lg:p-[0.5rem] py-[0.5rem] md:py-0 outline-none  "
                  />
                  <p className="border border-gray-700 hidden lg:block lg:px-[0.6rem] lg:py-[0.7rem] 2xl:p-[0.7rem]">
                    <FiSearch />
                  </p>
                </div>
              </div> */}

              <div className="px-[1rem] mt-2">
                <label htmlFor="username">UserName</label>
                <div className="border border-gray-700 overflow-hidden mt-2 flex justify-start items-center">
                  <input
                    value={loginNameToFilter}
                    onChange={(e) => setLoginNameToFilter(e.target.value)}
                    id="username"
                    type={"text"}
                    className=" lg:flex-grow md:px-[0.5rem] lg:p-[0.5rem] border-none py-[0.5rem] md:py-0 outline-none "
                  />
                  <p className="border border-gray-700 hidden lg:block lg:px-[0.6rem] lg:py-[0.7rem]  2xl:p-[0.7rem]">
                    <FiSearch />
                  </p>
                </div>
              </div>
              <div className="px-[1rem] mt-4">
                <p>User role</p>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={userRoleToFilter}
                    name="radio-buttons-group"
                    onChange={(e) => setUserRoleFilter(e.target.value)}>
                    <FormControlLabel
                      value="admin"
                      control={<Radio />}
                      label="admin"
                      onClick={() => handleUserRole("admin")}
                    />
                    <FormControlLabel
                      value="manager"
                      control={<Radio />}
                      label="manager"
                      onClick={() => handleUserRole("manager")}
                    />
                    <FormControlLabel
                      value="senior_agent"
                      control={<Radio />}
                      label="senior_agent"
                      onClick={() => handleUserRole("senior_agent")}
                    />
                    <FormControlLabel
                      value="agent"
                      control={<Radio />}
                      label="agent"
                      onClick={() => handleUserRole("agent")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="px-[1rem] mt-4">
                <p>Status</p>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={statusToFilter}
                    name="radio-buttons-group"
                    onChange={(e) => setStatusToFilter(e.target.value)}>
                    <FormControlLabel
                      value="Active"
                      control={<Radio />}
                      label="active"
                      onClick={() => handleUserStatus("Active")}
                    />
                    <FormControlLabel
                      value="deactivated"
                      control={<Radio />}
                      label="deactivated"
                      onClick={() => handleUserStatus("deactivated")}
                    />
                    <FormControlLabel
                      value="Unconfirmed"
                      control={<Radio />}
                      label="unconfirmed"
                      onClick={() => handleUserStatus("Unconfirmed")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div
                style={{ backgroundColor: coloredTheme }}
                onClick={createUserHandler}
                className="flex justify-center items-center space-x-2  text-purple-50  p-[0.5rem] cursor-pointer  transition duration-[0.6s] hover:shadow-2xl hover:shadow-black mt-4">
                <MdAdd className="text-[1.5rem]" />
                <p>Create User</p>
              </div>
            </div>

            {/* right portion */}
            <div className="xl:col-span-9 md:col-span-8 overflow-scroll mb-[2rem]">
              {filteredData.length ? (
                <table className=" table-auto w-[250%]  md:w-[100%]">
                  <thead className="  h-[5vh]">
                    <tr>
                      <th className="text-start">Login Name</th>
                      <th className="text-start">Full Name</th>
                      <th className="text-start">User Role</th>
                      <th className="text-start">Status</th>

                      {userDataFromStorage.user_role === "admin" ? (
                        <th className="text-start">Manager</th>
                      ) : (
                        ""
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((x, index) => {
                      console.log("x", x);
                      return (
                        <tr
                          onClick={() => usersModalHandler(x)}
                          key={index}
                          className={
                            index % 2 === 0
                              ? "h-[5vh] bg-white hover:bg-teal-700 transition duration-[1s] cursor-pointer hover:shadow-2xl hover:shadow-black hover:text-white"
                              : "h-[5vh] hover:bg-yellow-700 transition duration-[1s] hover:shadow-2xl hover:shadow-black hover:text-white cursor-pointer"
                          }>
                          <td className="">{x.login_name}</td>
                          <td>
                            {`${x.first_name ? x.first_name : ""}` +
                              `${x.last_name}`}
                          </td>
                          <td>
                            {x.is_admin === true
                              ? "admin"
                              : x.is_manager === true
                              ? "manager"
                              : x.is_agent === true
                              ? "agent"
                              : x.is_senior_agent === true
                              ? "senior agent"
                              : "---"}
                          </td>
                          <td>{x.status}</td>
                          {userDataFromStorage.user_role === "admin" ? (
                            <td>{x?.managerName}</td>
                          ) : (
                            ""
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <Box className="w-[100%]">
                  <Paper
                    elevation={3}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "4rem 0rem",
                    }}>
                    <p className="text-[1.2rem] font-[600] tracking-wider">
                      No User Details Found !!!
                    </p>
                  </Paper>
                </Box>
              )}
            </div>
          </div>
        </>
      )}

      {/* ADD USER MODAL */}
      <Modal
        open={open}
        onClose={() => {
          setAddUserData({
            first_name: "",
            last_name: "",
            login_name: "",
            mobile_number: null,
            password: "",
            gender: "",
            user_role: "",
            state: "",
            street_name: "",
            post_code: "",
            status: "Active",
            manager: null,
            house_number: null,
            id_number: "",
            initials: null,
            suburb: null,
            start_date: "",
          });
          handleClose();
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Create User</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* login name (Required) */}
                <div className="grid grid-cols-4 ">
                  <label
                    htmlFor="loginName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Login name</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="text"
                    id="loginName"
                    onChange={(e) => {
                      if (userDataFromStorage.user_role === "admin") {
                        setAddUserData((prevState) => ({
                          ...prevState,
                          login_name: e.target.value,
                        }));
                      } else if (userDataFromStorage.user_role === "manager") {
                        setAddUserData((prevState) => ({
                          ...prevState,
                          login_name: e.target.value,
                          user_role: "agent",
                          manager: userDataFromStorage.employee_number,
                        }));
                      }
                    }}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Login Name"
                  />
                </div>

                {/* User Role (Required)*/}
                {userDataFromStorage.user_role === "admin" ? (
                  <div className="grid grid-cols-4 mt-2 ">
                    <p className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">User Role</span>
                      <span className="text-red-600 text-lg">*</span>
                    </p>

                    <FormControl className="col-span-3">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={(e) =>
                          setAddUserData((prevState) => ({
                            ...prevState,
                            user_role: e.target.value,
                          }))
                        }>
                        <FormControlLabel
                          value="admin"
                          control={<Radio />}
                          label="Administrator"
                        />
                        <FormControlLabel
                          value="manager"
                          control={<Radio />}
                          label="Manager"
                        />
                        <FormControlLabel
                          value="senior_agent"
                          control={<Radio />}
                          label="Senior Agent"
                        />
                        <FormControlLabel
                          value="agent"
                          control={<Radio />}
                          label="Agent"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                ) : (
                  ""
                )}

                {userDataFromStorage.user_role === "manager" ? (
                  <div className="grid grid-cols-4 mt-2 ">
                    <p className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">User Role</span>
                      <span className="text-red-600 text-lg">*</span>
                    </p>

                    <FormControl className="col-span-3">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value="agent">
                        <FormControlLabel
                          value="agent"
                          control={<Radio />}
                          label="Agent"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                ) : (
                  ""
                )}

                {/* password */}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="password"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Password</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        password: e.target.value,
                      }))
                    }
                    type="password"
                    id="password"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User password "
                  />
                </div>

                {/*Confirm password */}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="confirmPassword"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Confirm Password</span>
                  </label>
                  <input
                    onChange={(e) => setConfirmPass(e.target.value)}
                    type="password"
                    id="confirmPassword"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Confirm User password "
                  />
                </div>

                {/*First Name */}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="firstName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">First/Given Name</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        first_name: e.target.value,
                      }))
                    }
                    value={addUserData?.first_name}
                    type="text"
                    id="firstName"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User First Name"
                  />
                </div>

                {/*Initials*/}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="initial"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Initials</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        initials: e.target.value,
                      }))
                    }
                    type="text"
                    id="initial"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Initials"
                  />
                </div>

                {/*last name*/}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="lastName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Last/Family Name</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        last_name: e.target.value,
                      }))
                    }
                    type="text"
                    id="lastName"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Last Name"
                  />
                </div>

                {/* gender */}
                <div className="grid grid-cols-4 mt-2 ">
                  <p className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Gender</span>
                  </p>

                  <FormControl className="col-span-3">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label1"
                      name="row-radio-buttons-group1"
                      onChange={(e) =>
                        setAddUserData((prevState) => ({
                          ...prevState,
                          gender: e.target.value,
                        }))
                      }>
                      <FormControlLabel
                        value="male"
                        control={<Radio />}
                        label="Male"
                      />
                      <FormControlLabel
                        value="female"
                        control={<Radio />}
                        label="Female"
                      />
                      <FormControlLabel
                        value="other"
                        control={<Radio />}
                        label="Other"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>

                {/* start Date */}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="startDate"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Start Date</span>
                  </label>
                  <input
                    id="startDate"
                    type="date"
                    placeholder="Select Start Date"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        start_date: new Date(e.target.value),
                      }))
                    }
                  />
                </div>

                {/* Manager's Name */}
                {userDataFromStorage.user_role === "admin" && (
                  <div className="grid grid-cols-4 mt-2 ">
                    <p className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Manager's Name</span>
                    </p>

                    <select
                      onChange={(e) =>
                        setAddUserData((prevState) => ({
                          ...prevState,
                          manager: e.target.value,
                        }))
                      }
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3">
                      <option value={"none"}>Select Manager</option>
                      {managerList.length ? (
                        managerList.map((x, index) => (
                          <option key={index} value={x.employee_number}>
                            {x.login_name}
                          </option>
                        ))
                      ) : (
                        <>
                          <option value={"manager1"}>Manager 1</option>
                          <option value={"manager2"}>Manager 2</option>
                          <option value={"manager3"}>Manager 3</option>
                          <option value={"manager4"}>Manager 4</option>
                        </>
                      )}
                    </select>
                  </div>
                )}

                {/*ID Number*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="idNumber"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">ID Number</span>
                  </label>

                  <input
                    id="idNumber"
                    type="number"
                    placeholder="Enter a Id Number"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        id_number: e.target.value,
                      }))
                    }
                  />
                </div>

                {/*House Number*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="houseNo"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">House Number</span>
                  </label>

                  <input
                    id="houseNo"
                    type="test"
                    placeholder="Enter a House Number"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        house_number: e.target.value,
                      }))
                    }
                  />
                </div>

                {/*Street Name*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="street"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Street Name</span>
                  </label>

                  <input
                    id="street"
                    type="text"
                    placeholder="Enter Street Name"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        street_name: e.target.value,
                      }))
                    }
                  />
                </div>

                {/*Suburb*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="suburb"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Suburb</span>
                  </label>

                  <input
                    id="suburb"
                    type="text"
                    placeholder="Enter a Suburb"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        suburb: e.target.value,
                      }))
                    }
                  />
                </div>

                {/*State*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="idNumber"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">State</span>
                  </label>

                  <select
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        state: e.target.value,
                      }))
                    }
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3">
                    <option value={"none"}>Select State</option>
                    {stateList.map((x, index) => (
                      <option key={index} value={x.name}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/*Post Code*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="postCode"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Post Code</span>
                  </label>

                  <input
                    id="postCode"
                    type="number"
                    placeholder="Enter a Post Code"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        post_code: parseInt(e.target.value),
                      }))
                    }
                  />
                </div>

                {/*Mobile Number*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="phone"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Mobile Number</span>
                  </label>

                  <input
                    id="phone"
                    type="tel"
                    placeholder="Enter User's Mobile Number"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    onChange={(e) =>
                      setAddUserData((prevState) => ({
                        ...prevState,
                        mobile_number: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => {
                      setAddUserData({
                        first_name: "",
                        last_name: "",
                        login_name: "",
                        mobile_number: null,
                        password: "",
                        gender: "",
                        user_role: "",
                        state: "",
                        street_name: "",
                        post_code: "",
                        status: "Active",
                        manager: null,
                        house_number: null,
                        id_number: "",
                        initials: null,
                        suburb: null,
                        start_date: "",
                      });
                      setOpen(false);
                    }}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={handleUserRegistration}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* USER DETAIL MODAL */}
      <Modal
        open={userOpen}
        onClose={handleUserClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          <div className="p-[0.5rem]">
            <p className="text-lg text-gray-800">
              User Info for : {userModalData?.first_name}
            </p>
          </div>
          <Divider />
          <div className="p-[0.5rem]">
            <div className=" flex  justify-start items-start mt-4">
              <button
                onClick={() => editUserModalHandler()}
                className="flex justify-center items-center bg-gray-200 px-[1rem] py-[0.3rem] rounded-tl-lg rounded-bl-lg hover:bg-gray-800 hover:text-white hover:shadow-2xl hover:shadow-black space-x-1 transition duration-[1s]">
                <FaRegEdit />
                <span>Edit</span>
              </button>
              <button
                onClick={() => setPasswordModalOpen(true)}
                className="flex justify-center items-center bg-gray-200 px-[1rem] py-[0.3rem]  hover:bg-gray-800 hover:text-white hover:shadow-2xl hover:shadow-black space-x-1 transition duration-[1s]">
                <AiOutlineUnlock />
                <span>Change Password</span>
              </button>
              <button
                onClick={() => setDeleteModalUser(true)}
                className="flex justify-center items-center bg-gray-200 px-[1rem] py-[0.3rem] rounded-tr-lg rounded-br-lg hover:bg-gray-800 hover:text-white hover:shadow-2xl hover:shadow-black space-x-1 transition duration-[1s]">
                <MdDeleteOutline />
                <span>Delete</span>
              </button>
            </div>
            <div className="flex justify-between items-center mt-4 mb-2">
              <p className=" text-gray-800 w-[50%]">Login Name</p>
              <p className=" text-gray-800 w-[50%]">
                {userModalData?.login_name}
              </p>
            </div>
            <Divider />
            <div className="flex justify-between items-center mt-4 mb-2">
              <p className=" text-gray-800 w-[50%]">Full Name</p>
              <p className=" text-gray-800 w-[50%]">
                {`${
                  userModalData?.first_name ? userModalData?.first_name : ""
                }` + `${userModalData?.last_name}`}
              </p>
            </div>
            <Divider />

            <div className="flex justify-between items-center mt-4 mb-2">
              <p className=" text-gray-800 w-[50%]">User Role</p>
              <p className=" text-gray-800 w-[50%]">
                {userModalData?.is_admin
                  ? "Admin"
                  : userModalData?.is_manager
                  ? "Manager"
                  : userModalData?.is_agent
                  ? "Agent"
                  : userModalData?.is_senior_agent
                  ? "Senior Agent"
                  : ""}
              </p>
            </div>
            <Divider />

            <div className="flex justify-between items-center mt-4 mb-2">
              <p className=" text-gray-800 w-[50%]">Date Created</p>
              <p className=" text-gray-800 w-[50%]">
                {userModalData?.start_date}
              </p>
            </div>
            <Divider />

            <div className="flex justify-between items-center mt-4 mb-6">
              <p className=" text-gray-800 w-[50%]">Last Login Date</p>
              <p className=" text-gray-800 w-[50%]">
                {userModalData?.last_login_date
                  ? userModalData?.last_login_date
                  : "Not Logged In yet !!!"}
              </p>
            </div>
            <Divider />
            <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
              <button
                onClick={() => setUserOpen(false)}
                className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                <TbArrowBackUp />
                <p>Cancel</p>
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* EDIT USER MODAL */}
      <Modal
        open={editUser}
        onClose={handleEditUserClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Edit User's Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/*employee ID*/}
                <div className="grid grid-cols-4 ">
                  <p className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Employee ID</span>
                  </p>
                  <p className="p-[0.5rem] flex-1  col-span-3">
                    {editUserData?.employee_id}
                  </p>
                </div>

                {/* start Date */}
                <div className="grid grid-cols-4 mt-2">
                  <p className=" text-gray-700 col-span-1">Start Date</p>
                  <p className=" text-gray-700 col-span-3">
                    {editUserData?.start_date}
                  </p>
                </div>

                {/* last login Date */}
                <div className="grid grid-cols-4 mt-2">
                  <p className=" text-gray-700 col-span-1">Last Login Date</p>
                  <p className=" text-gray-700 col-span-3">
                    {editUserData.last_login_date
                      ? editUserData.last_login_date
                      : "not yet Logged In !!!"}
                  </p>
                </div>

                {/* status*/}
                <div className="grid grid-cols-4 mt-2">
                  <p className=" text-gray-700 col-span-1">Status</p>
                  <p className=" text-gray-700 col-span-3">
                    {editUserData.status
                      ? editUserData.status
                      : "UnConfirmed!!!"}
                  </p>
                </div>

                {/* Id_number*/}
                <div className="grid grid-cols-4 mt-2">
                  <p className=" text-gray-700 col-span-1">ID Number</p>
                  <p className=" text-gray-700 col-span-3">
                    {editUserData.employee_number
                      ? editUserData.employee_number
                      : ""}
                  </p>
                </div>

                {/* mobile_number*/}
                <div className="grid grid-cols-4 mt-2">
                  <p className=" text-gray-700 col-span-1">Mobile Number</p>
                  <p className=" text-gray-700 col-span-3">
                    {editUserData.mobile_number
                      ? editUserData.mobile_number
                      : ""}
                  </p>
                </div>

                {/* login_name*/}
                <div className="grid grid-cols-4 mt-2">
                  <p className=" text-gray-700 col-span-1">Login Name</p>
                  <p className=" text-gray-700 col-span-3">
                    {editUserData.login_name ? editUserData.login_name : ""}
                  </p>
                </div>

                {/*First Name*/}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="editFirstName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">First Name</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        first_name: e.target.value,
                      }))
                    }
                    value={editUserData?.first_name}
                    type="text"
                    id="editFirstName"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter A First Name"
                  />
                </div>

                {userDataFromStorage.user_role === "admin" ? (
                  <div className="grid grid-cols-4 mt-2 ">
                    <p className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">User Role</span>
                      <span className="text-red-600 text-lg">*</span>
                    </p>

                    <FormControl className="col-span-3">
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={(e) =>
                          setEditUserData((prevState) => ({
                            ...prevState,
                            user_role: e.target.value,
                          }))
                        }
                        value={editUserData.user_role}>
                        <FormControlLabel
                          value="admin"
                          control={<Radio />}
                          label="Administrator"
                        />
                        <FormControlLabel
                          value="manager"
                          control={<Radio />}
                          label="Manager"
                        />
                        <FormControlLabel
                          value="senior_agent"
                          control={<Radio />}
                          label="Senior Agent"
                        />
                        <FormControlLabel
                          value="agent"
                          control={<Radio />}
                          label="Agent"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                ) : (
                  ""
                )}

                {/*Initials*/}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="editInitials"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Initials</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        initials: e.target.value,
                      }))
                    }
                    value={editUserData.initials ? editUserData.initials : ""}
                    type="text"
                    id="editInitials"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Initials"
                  />
                </div>

                {/*Last Name*/}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="editLastName"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Last/Family Name</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        last_name: e.target.value,
                      }))
                    }
                    value={editUserData?.last_name}
                    type="text"
                    id="editLastName"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter A Last Name"
                  />
                </div>

                {/* User Role (Required)*/}
                {/* <div className='grid grid-cols-4 mt-2 '>
                                    <p className='flex justify-start items-center col-span-1 space-x-1'><span className='text-gray-700'>User Role</span><span className='text-red-600 text-lg'>*</span></p>


                                    <FormControl className='col-span-3'>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            value={
                                                editUserData.user_role
                                            }
                                            onChange={handleUserRoleChange}
                                        >
                                            <FormControlLabel value="admin" control={<Radio />} label="Administrator" />
                                            <FormControlLabel value="manager" control={<Radio />} label="Manager" />
                                            <FormControlLabel value="senior_agent" control={<Radio />} label="Senior Agent" />
                                            <FormControlLabel value="agent" control={<Radio />} label="Agent" />
                                        </RadioGroup>
                                    </FormControl>

                                </div> */}

                {/* Manager's Name */}
                {userDataFromStorage.user_role === "admin" ? (
                  <div className="grid grid-cols-4 mt-2 ">
                    <p className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Manager's Name</span>
                    </p>

                    <select
                      onChange={(e) =>
                        setEditUserData((prevState) => ({
                          ...prevState,
                          manager: e.target.value,
                        }))
                      }
                      value={editUserData.manager ? editUserData.manager : ""}
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3">
                      <option value={"none"}>Select A Manager</option>
                      {managerList.length ? (
                        managerList.map((x, index) => (
                          <option key={index} value={x.employee_number}>
                            {x.login_name}
                          </option>
                        ))
                      ) : (
                        <>
                          <option value={"manager1"}>Manager 1</option>
                          <option value={"manager2"}>Manager 2</option>
                          <option value={"manager3"}>Manager 3</option>
                          <option value={"manager4"}>Manager 4</option>
                        </>
                      )}
                    </select>
                  </div>
                ) : (
                  ""
                )}

                {/*House Number*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="editHouseNumber"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">House Number</span>
                  </label>

                  <input
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        house_number: e.target.value,
                      }))
                    }
                    id="editHouseNumber"
                    type="test"
                    placeholder="Enter a House Number"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    value={editUserData?.house_number}
                  />
                </div>

                {/*Street Name*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="editStreet"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Street Name</span>
                  </label>

                  <input
                    id="editStreet"
                    type="text"
                    placeholder="Enter Street Name"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    value={editUserData?.street_name}
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        street_name: e.target.value,
                      }))
                    }
                  />
                </div>

                {/*Suburb*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="editSuburb"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Suburb</span>
                  </label>

                  <input
                    id="editSuburb"
                    type="text"
                    placeholder="Enter a Suburb"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    value={editUserData?.suburb}
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        suburb: e.target.value,
                      }))
                    }
                  />
                </div>

                {/*State*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="editState"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">State</span>
                  </label>

                  <select
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        state: e.target.value,
                      }))
                    }
                    value={editUserData?.state}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3">
                    <option value={"none"}>Select A State</option>
                    {stateList.map((x, index) => (
                      <option key={index} value={x.name}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/*Post Code*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <label
                    htmlFor="editPostCode"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Post Code</span>
                  </label>

                  <input
                    id="editPostCode"
                    type="number"
                    placeholder="Enter a Post Code"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    value={editUserData?.post_code}
                    onChange={(e) =>
                      setEditUserData((prevState) => ({
                        ...prevState,
                        post_code: parseInt(e.target.value),
                      }))
                    }
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setEditUser(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={handleUserEditHandler}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        open={deleteModalUser}
        onClose={handleDeleteModal}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="2xl:w-[40%] xl:w-[35%] lg:w-[50%] md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          <div className="p-[0.8rem]">
            <p className="text-lg text-gray-800">Delete User Account</p>
          </div>
          <Divider />
          <div className="p-[1rem]">
            <p className="text-[1.2rem] tracking-wider text-gray-800 text-center font-[600]">
              Are You Sure , You Want To Deactivate {userModalData?.first_name}
            </p>
            <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
              <button
                onClick={() => setDeleteModalUser(false)}
                className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                <TbArrowBackUp />
                <p>Cancel</p>
              </button>
              <button
                onClick={deleteUserByAdminHandler}
                className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                <RiSave2Fill />
                <p>Save</p>
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* change password User Modal */}
      <Modal
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[95%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Update User Password</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="newPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">New Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPass((prevState) => ({
                        ...prevState,
                        new_password: e.target.value,
                      }))
                    }
                    value={editPass?.new_password}
                    type="text"
                    id="newPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User New Password"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="confirmNewPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Confirm Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPass((prevState) => ({
                        ...prevState,
                        confirm_password: e.target.value,
                      }))
                    }
                    value={editPass?.confirm_password}
                    type="text"
                    id="confirmNewPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Confirm New Password"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setPasswordModalOpen(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={updatePasswordByAdminHandler}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Users;
